/* eslint-disable react-hooks/rules-of-hooks */
import { axiosInstance } from "@/lib/axiosInstance";
import config from "@/lib/config";
import axios from "axios";

export async function confirmMpesaPayment(checkoutRequestID: string) {
  try {
    const response = await axiosInstance.post(
      `${config.apiUrl}/payments/mpesa/confirm-payment/${checkoutRequestID}`,
    );
    return response.data.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      console.error("Axios error:", error.response?.data);
    } else {
      console.error("Unknown error:", error);
    }
    throw error;
  }
}
